import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { RaisonVenue } from '../models/options/rainsonsVenue/raisonVenue';
import { PrecisionRaisonVenue } from '../models/options/precisionsRaisonVenue/precisionRaisonVenue';

const resource = 'PrecisionsRaisonVenue'

export default class PrecisionsRaisonVenueRessource {
  public async paginatedList(pagenumber?: number, pagesize?: number, search?: string) : Promise<PaginatedList<PrecisionRaisonVenue>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString()); 

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
